export default __webpack_public_path__ + "static/media/arrowRightBlue.f763d41a.svg";